/**
 * Hook to track route changes for analytics
 * Place in a top-level component that has access to React Router context
 */
import { useEffect, useRef } from "react";
import { useLocation } from "react-router";
import {
  trackPageView,
  startSession,
  isSessionActive,
  updateSessionUserId,
} from "../services/analytics-service";
import { db } from "../instantdb";

export function useRouteAnalytics() {
  const location = useLocation();
  const { user } = db.useAuth();
  const previousPath = useRef<string | null>(null);
  const hasStartedSession = useRef(false);

  // Start session on mount and update user ID when user logs in
  useEffect(() => {
    if (!hasStartedSession.current) {
      hasStartedSession.current = true;
      startSession(user?.id);
    } else if (user?.id && isSessionActive()) {
      // User logged in after session started - update the session
      updateSessionUserId(user.id);
    }
  }, [user?.id]);

  // Track route changes
  useEffect(() => {
    const currentPath = location.pathname;

    // Skip if same path (prevents double-tracking on initial load)
    if (currentPath === previousPath.current) return;

    previousPath.current = currentPath;
    trackPageView(currentPath);
  }, [location.pathname]);
}
